module.exports = __webpack_public_path__ + "static/media/001-boy.45d15c02.svg";